
// This file now just re-exports the refactored BookingFormContainer
import { BookingFormContainer } from "./booking/BookingFormContainer";

export const BookingForm = BookingFormContainer;
